/* =========================================================
   FURNIVERSAL — Shopify runtime glue
   ---------------------------------------------------------
   Runs before the original site scripts (content.js, main.js)
   and gives them what the PHP site used to provide:

     window.FV_URL(path)   legacy site links / asset paths → Shopify URLs
     savedContent()        theme-editor settings → the content object
     catalogue()           Shopify products (+ bundled fallback) → the
                           product shape main.js already understands
     buy form + cart       "Add to cart" / "Buy now" on the product page

   Configuration is written by layout/theme.liquid into
   window.FV_SHOPIFY_CONFIG.
   ========================================================= */
(function () {
  "use strict";

  var CFG = window.FV_SHOPIFY_CONFIG || {};
  var routes = CFG.routes || {};
  var pages = CFG.pages || {};
  var assetBase = CFG.assetBase || "/assets/";
  var LABELS = CFG.labels || {};

  function esc(s) {
    return String(s === null || s === undefined ? "" : s)
      .replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  function t(key, fallback) { var v = LABELS[key]; return (v === undefined || v === null || v === "") ? fallback : v; }

  /* ---------------------------------------------------------
     1. URL mapping
     --------------------------------------------------------- */
  function flat(p) {
    return String(p).replace(/^assets\//, "").replace(/[?#].*$/, "").replace(/\//g, "-");
  }
  function url(href) {
    var h = String(href === null || href === undefined ? "" : href);
    if (!h) return h;
    if (/^assets\//.test(h)) return assetBase + flat(h);
    var m = h.match(/^(index|shop|product|showroom|support|brands|interiors)\.html(\?[^#]*)?(#.*)?$/i);
    if (!m) return h;
    var page = m[1].toLowerCase(), q = m[2] || "", hash = m[3] || "";
    if (page === "index") return (routes.root || "/") + hash;
    if (page === "shop") return (routes.all || "/collections/all") + q + hash;
    if (page === "product") {
      var pm = q.match(/[?&]p=([^&]+)/);
      if (!pm) return (routes.all || "/collections/all") + hash;
      return (routes.products || "/products") + "/" + decodeURIComponent(pm[1]) + hash;
    }
    return (pages[page] || ("/pages/" + page)) + q + hash;
  }
  window.FV_URL = url;

  // Anything the original scripts still write with a legacy path is fixed
  // here, so no link or image on the page can point at the old site.
  var ATTRS = { A: ["href"], IMG: ["src"], SOURCE: ["src"], VIDEO: ["src", "poster"], LINK: ["href"] };
  function fixEl(el) {
    var attrs = ATTRS[el.tagName];
    if (!attrs) return;
    attrs.forEach(function (a) {
      var v = el.getAttribute(a);
      if (!v) return;
      var n = url(v);
      if (n === v) return;
      el.setAttribute(a, n);
      if (el.tagName === "SOURCE") {
        var vid = el.closest("video");
        if (vid) { try { vid.load(); } catch (e) {} }
      }
    });
  }
  function sweep(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    if (scope !== document) fixEl(scope);
    scope.querySelectorAll("a[href],img[src],source[src],video[src],video[poster],link[href]").forEach(fixEl);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === "attributes") { fixEl(m.target); return; }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) sweep(n); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["href", "src", "poster"] });
  }
  sweep();

  /* ---------------------------------------------------------
     2. Content from the theme editor
     --------------------------------------------------------- */
  // Lists that live in Theme settings as "a | b | c" lines
  var PIPE_LISTS = {
    "product.customise.steps": ["num", "title", "text"],
    "global.swatches.fabric": ["name", "hex"],
    "global.swatches.leather": ["name", "hex"]
  };
  function pipeList(text, fields) {
    return String(text || "").split("\n").map(function (l) { return l.trim(); }).filter(Boolean).map(function (line) {
      var parts = line.split("|").map(function (x) { return x.trim(); });
      var o = {};
      fields.forEach(function (f, i) { o[f] = parts[i] || ""; });
      return o;
    });
  }
  function unflatten(flatObj) {
    var out = {};
    Object.keys(flatObj).forEach(function (k) {
      var parts = k.split("."), node = out;
      for (var i = 0; i < parts.length - 1; i++) {
        if (!node[parts[i]] || typeof node[parts[i]] !== "object" || Array.isArray(node[parts[i]])) node[parts[i]] = {};
        node = node[parts[i]];
      }
      node[parts[parts.length - 1]] = flatObj[k];
    });
    return out;
  }
  function savedContent() {
    var flatObj = {};
    document.querySelectorAll('script[type="application/json"][data-fv-content]').forEach(function (s) {
      try { Object.assign(flatObj, JSON.parse(s.textContent)); } catch (e) { if (window.console) console.warn("Furniversal: content JSON in section could not be read", e); }
    });
    Object.keys(PIPE_LISTS).forEach(function (k) {
      if (typeof flatObj[k] === "string") flatObj[k] = pipeList(flatObj[k], PIPE_LISTS[k]);
    });
    // product handles typed one per line in the theme editor
    if (typeof flatObj["home.featured.slugs"] === "string") {
      flatObj["home.featured.slugs"] = flatObj["home.featured.slugs"].split("\n").map(function (l) { return l.trim().toLowerCase(); }).filter(Boolean);
    }
    return unflatten(flatObj);
  }

  /* ---------------------------------------------------------
     3. Products
     --------------------------------------------------------- */
  function parseProducts() {
    var s = document.querySelector('script[type="application/json"][data-fv-products]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { if (window.console) console.warn("Furniversal: product JSON could not be read", e); return null; }
  }
  function trim(s) { return String(s === null || s === undefined ? "" : s).trim(); }
  function first(arr) { return Array.isArray(arr) && arr.length ? arr[0] : undefined; }
  function pick() { for (var i = 0; i < arguments.length; i++) { var v = arguments[i]; if (v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && !v.length)) return v; } return undefined; }
  function asList(v) {
    if (Array.isArray(v)) return v;
    if (typeof v === "string" && v.trim()) {
      try { var j = JSON.parse(v); if (Array.isArray(j)) return j; } catch (e) {}
      return v.split("\n").map(trim).filter(Boolean);
    }
    return [];
  }
  function asDims(v) {
    if (!v) return undefined;
    if (typeof v === "object" && !Array.isArray(v)) return (v.w || v.d || v.h) ? { w: +v.w || 0, d: +v.d || 0, h: +v.h || 0 } : undefined;
    var s = String(v);
    try { var j = JSON.parse(s); if (j && typeof j === "object") return asDims(j); } catch (e) {}
    var m = s.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)/i);
    return m ? { w: +m[1], d: +m[2], h: +m[3] } : undefined;
  }
  function specTags(tags) {
    var spec = {}, cats = [];
    (tags || []).forEach(function (raw) {
      var tag = trim(raw);
      var i = tag.indexOf(":");
      if (i > 0) {
        var k = tag.slice(0, i).trim().toLowerCase(), v = tag.slice(i + 1).trim();
        (spec[k] = spec[k] || []).push(v);
      } else if (tag) cats.push(tag);
    });
    return { spec: spec, cats: cats };
  }
  function parseDescription(html) {
    var out = { description: "", features: [] };
    if (!html) return out;
    try {
      var doc = new DOMParser().parseFromString("<div>" + html + "</div>", "text/html");
      var root = doc.body.firstChild;
      var ul = root.querySelector("ul");
      if (ul) {
        out.features = Array.prototype.map.call(ul.querySelectorAll("li"), function (li) { return trim(li.textContent); }).filter(Boolean);
        ul.parentNode.removeChild(ul);
      }
      out.description = trim(root.textContent).replace(/\s*\n\s*/g, " ");
    } catch (e) {
      out.description = trim(String(html).replace(/<[^>]+>/g, " ")).replace(/\s+/g, " ");
    }
    return out;
  }
  function optionValues(sp, name) {
    var o = (sp.options || []).find(function (x) { return String(x.name || "").toLowerCase() === name; });
    return o && Array.isArray(o.values) ? o.values.filter(function (v) { return v && v !== "Default Title"; }) : [];
  }
  function mapProduct(sp, b) {
    b = b || {};
    var mf = sp.mf || {};
    var st = specTags(sp.tags);
    var spec = st.spec;
    var cats = st.cats.slice();
    if (sp.type && cats.indexOf(sp.type) === -1) cats.unshift(sp.type);
    else if (sp.type) { cats.splice(cats.indexOf(sp.type), 1); cats.unshift(sp.type); }
    if (!cats.length) cats = (b.categories && b.categories.length) ? b.categories.slice() : (b.category ? [b.category] : []);

    var desc = parseDescription(sp.description_html);
    // configuration chips: the variant options plus any extra "config:" tags (e.g. "Custom size", which is not sold online)
    var configs = asList(mf.configs);
    if (!configs.length) {
      configs = optionValues(sp, "configuration").slice();
      (spec.config || []).forEach(function (c) { if (configs.indexOf(c) === -1) configs.push(c); });
    }
    if (!configs.length) configs = b.configs || [];
    var colours = pick(asList(mf.colours), (spec.swatch || []).map(function (s) {
      var parts = s.split("|"); return { name: trim(parts[0]), hex: trim(parts[1] || "") };
    }), optionValues(sp, "colour").concat(optionValues(sp, "color")).map(function (n) { return { name: n, hex: "" }; }), b.colours) || [];
    var images = (sp.images && sp.images.length) ? sp.images : (b.images || []);
    var videos = (sp.videos && sp.videos.length) ? sp.videos : (b.videos || []);

    return {
      slug: sp.slug,
      name: pick(sp.name, b.name) || sp.slug,
      url: sp.url,
      categories: cats,
      category: cats[0] || "",
      tagline: pick(mf.tagline, first(spec.tagline), b.tagline) || "",
      material: pick(mf.material, first(spec.material), b.material) || "",
      colour: pick(mf.colour, first(spec.colour), first(spec.color), colours.length ? colours[0].name : "", b.colour) || "",
      seating: pick(mf.seating, first(spec.seating), b.seating) || "",
      comfort: pick(mf.comfort, first(spec.comfort), b.comfort) || "",
      family: pick(mf.family, first(spec.family), b.family) || "",
      price: pick(Number(sp.price) || 0, b.price) || 0,
      dimensions: pick(asDims(mf.dimensions), asDims(first(spec.dim) || first(spec.dimensions)), b.dimensions) || {},
      configs: configs,
      colours: colours,
      description: pick(mf.description, desc.description, b.description) || "",
      features: pick(asList(mf.features), desc.features, b.features) || [],
      images: images,
      videos: videos,
      available: sp.available !== false,
      options: sp.options || [],
      variants: sp.variants || []
    };
  }
  var catalogueCache = null;
  function catalogue(force) {
    if (catalogueCache && !force) return catalogueCache;
    var data = parseProducts();
    var bundled = window.FURNIVERSAL_PRODUCTS || [];
    var bySlug = {};
    bundled.forEach(function (p) { bySlug[p.slug] = p; });
    var cats = String(data && data.categoriesText || "").split("\n").map(trim).filter(Boolean);
    if (!cats.length) cats = window.FURNIVERSAL_CATEGORIES || [];
    var result;
    if (!data || !Array.isArray(data.products) || !data.products.length) {
      result = { categories: cats, products: bundled.slice(), mode: "bundled" };
    } else {
      var products = data.products.map(function (sp) { return mapProduct(sp, bySlug[sp.slug]); });
      if (data.current && data.current.slug && !products.some(function (p) { return p.slug === data.current.slug; })) {
        products.unshift(mapProduct(data.current, bySlug[data.current.slug]));
      }
      result = { categories: cats, products: products, mode: "shopify" };
    }
    document.documentElement.classList.remove("fv-mode-bundled", "fv-mode-shopify");
    document.documentElement.classList.add("fv-mode-" + result.mode);
    catalogueCache = result;
    return result;
  }

  /* ---------------------------------------------------------
     4. Product page: add to cart
     --------------------------------------------------------- */
  function formatINR(n) {
    n = Math.round(Number(n) || 0);
    if (!n) return "";
    var s = String(n), last3 = s.slice(-3), rest = s.slice(0, -3);
    if (rest) last3 = "," + last3;
    return "₹" + rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + last3;
  }
  function money(n) {
    if (CFG.currency && CFG.currency !== "INR") {
      try { return new Intl.NumberFormat(undefined, { style: "currency", currency: CFG.currency, maximumFractionDigits: 0 }).format(Number(n) || 0); } catch (e) {}
    }
    return formatINR(n);
  }
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l1 13H5z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';

  function buildBuy(p, root) {
    if (!p || !Array.isArray(p.variants) || !p.variants.length) return;
    var cta = root.querySelector(".pdp-cta");
    if (!cta || root.querySelector(".fv-buy")) return;

    var opts = (p.options || []).filter(function (o) {
      return o.values && o.values.length && !(o.values.length === 1 && o.values[0] === "Default Title");
    });
    var initial = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    var sel = opts.map(function (o, i) { return (initial.options && initial.options[i]) || o.values[0]; });

    var html = '<form class="fv-buy" id="fv-buy" novalidate>' +
      opts.map(function (o, i) {
        return '<div class="spec-block fv-opt-block"><div class="spec-label"><span>' + esc(o.name) + '</span><strong data-sel="' + i + '">' + esc(sel[i]) + "</strong></div>" +
          '<div class="chips fv-opt" data-opt="' + i + '">' + o.values.map(function (v) {
            return '<button type="button" class="' + (v === sel[i] ? "on" : "") + '" data-val="' + esc(v) + '">' + esc(v) + "</button>";
          }).join("") + "</div></div>";
      }).join("") +
      '<div class="fv-buy-row">' +
        '<div class="fv-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><input type="number" name="quantity" min="1" max="99" value="1" aria-label="Quantity"><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>' +
        '<div class="fv-buy-price"><small>' + esc(t("priceLabel", "Price")) + '</small><strong id="fv-buy-price"></strong></div>' +
      "</div>" +
      '<div class="field fv-buy-custom"><label for="fv-custom">' + esc(t("customLabel", "Customisation notes (optional)")) + '</label><textarea id="fv-custom" name="properties[Customisation]" rows="2" placeholder="' + esc(t("customPlaceholder", "Custom size, fabric, leather or colour requests")) + '"></textarea></div>' +
      '<div class="fv-buy-actions">' +
        '<button type="submit" class="btn btn-primary btn-lg" data-add>' + BAG + " <span>" + esc(t("add", "Add to cart")) + "</span></button>" +
        '<button type="button" class="btn btn-brass btn-lg" data-buy-now>' + esc(t("buy", "Buy now")) + "</button>" +
      "</div>" +
      (t("note", "") ? '<p class="fv-buy-note">' + esc(t("note", "")) + "</p>" : "") +
      '<p class="form-status fv-buy-status" hidden></p>' +
      "</form>";
    cta.insertAdjacentHTML("beforebegin", html);
    var form = root.querySelector("#fv-buy");
    var priceEl = form.querySelector("#fv-buy-price");
    var status = form.querySelector(".fv-buy-status");
    var addBtn = form.querySelector("[data-add]");
    var buyBtn = form.querySelector("[data-buy-now]");

    function current() {
      return p.variants.find(function (v) {
        return opts.every(function (o, i) { return (v.options || [])[i] === sel[i]; });
      }) || (opts.length ? null : p.variants[0]);
    }
    function show(msg, isError) {
      status.textContent = msg || "";
      status.hidden = !msg;
      status.classList.toggle("error", !!isError);
    }
    function refresh() {
      var v = current();
      var ok = !!(v && v.available);
      priceEl.textContent = v ? money(v.price) : "";
      addBtn.disabled = !ok;
      buyBtn.disabled = !ok;
      addBtn.querySelector("span").textContent = v ? (ok ? t("add", "Add to cart") : t("soldOut", "Made to order — enquire")) : t("unavailable", "Unavailable");
      form.querySelectorAll("[data-sel]").forEach(function (el) { el.textContent = sel[+el.getAttribute("data-sel")] || ""; });
    }
    form.addEventListener("click", function (e) {
      var chip = e.target.closest(".fv-opt button");
      if (chip) {
        var i = +chip.parentNode.getAttribute("data-opt");
        sel[i] = chip.getAttribute("data-val");
        chip.parentNode.querySelectorAll("button").forEach(function (b) { b.classList.toggle("on", b === chip); });
        refresh();
        return;
      }
      var q = e.target.closest("[data-q]");
      if (q) {
        var input = form.quantity;
        input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + (+q.getAttribute("data-q"))));
      }
    });
    function setBusy(b) { addBtn.disabled = b; buyBtn.disabled = b; form.classList.toggle("busy", b); }
    function add(then) {
      var v = current();
      if (!v || !v.available) { show(t("unavailable", "This option is not available to order online. Message us on WhatsApp."), true); return; }
      var qty = Math.min(99, Math.max(1, parseInt(form.quantity.value, 10) || 1));
      var props = {};
      var note = form.querySelector('[name="properties[Customisation]"]');
      if (note && note.value.trim()) props["Customisation"] = note.value.trim();
      setBusy(true);
      show(t("adding", "Adding to your cart…"));
      fetch((routes.cartAdd || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty, properties: props }] })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || "Could not add this to the cart.");
          return j;
        });
      }).then(function () {
        show(t("added", "Added to your cart."));
        then();
      }).catch(function (err) {
        setBusy(false);
        show(err && err.message ? err.message : "Could not add this to the cart.", true);
        refresh();
      });
    }
    form.addEventListener("submit", function (e) { e.preventDefault(); add(function () { window.location.href = routes.cart || "/cart"; }); });
    buyBtn.addEventListener("click", function () { add(function () { window.location.href = routes.checkout || "/checkout"; }); });

    var sticky = document.getElementById("pdp-sticky");
    if (sticky && !sticky.querySelector("[data-sticky-add]")) {
      sticky.insertAdjacentHTML("afterbegin", '<button type="button" class="btn btn-primary" data-sticky-add>' + BAG + " " + esc(t("add", "Add to cart")) + "</button>");
      sticky.querySelector("[data-sticky-add]").addEventListener("click", function () {
        form.scrollIntoView({ behavior: "smooth", block: "center" });
        add(function () { window.location.href = routes.cart || "/cart"; });
      });
    }
    refresh();
  }
  document.addEventListener("fv:product", function (e) {
    var d = e.detail || {};
    if (d.product && d.root) buildBuy(d.product, d.root);
  });

  /* ---------------------------------------------------------
     4b. /products/<name> for a piece not in Shopify yet (404 template):
         show it from the bundled catalogue. Runs before main.js boots.
     --------------------------------------------------------- */
  function productFallback() {
    if (CFG.template !== "404") return;
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    var slug = m ? decodeURIComponent(m[1]) : "";
    var list = window.FURNIVERSAL_PRODUCTS || [];
    var wrap = document.getElementById("fv-404-product"), nf = document.getElementById("fv-404");
    var found = slug && list.some(function (p) { return p.slug === slug; });
    if (found) {
      CFG.productHandle = slug;
      window.FV_SHOPIFY.productHandle = slug;
      if (wrap) wrap.hidden = false;
      if (nf) nf.hidden = true;
    } else if (wrap && wrap.parentNode) {
      wrap.parentNode.removeChild(wrap);
    }
  }
  // deferred scripts run before DOMContentLoaded, and products.js loads after this file
  if (document.readyState !== "complete") document.addEventListener("DOMContentLoaded", productFallback);
  else productFallback();

  /* ---------------------------------------------------------
     4c. Prices printed by Liquid (cart, search) in the site's ₹1,95,000 style
     --------------------------------------------------------- */
  function formatLiquidMoney(root) {
    (root || document).querySelectorAll("[data-fv-money]").forEach(function (el) {
      var cents = parseInt(el.getAttribute("data-fv-money"), 10);
      if (!isNaN(cents)) el.textContent = money(cents / 100);
    });
  }
  if (document.readyState !== "complete") document.addEventListener("DOMContentLoaded", function () { formatLiquidMoney(); });
  else formatLiquidMoney();

  /* ---------------------------------------------------------
     5. Cart page quantity buttons
     --------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var q = e.target.closest(".fv-cart [data-q]");
    if (!q) return;
    var input = q.parentNode.querySelector("input");
    if (!input) return;
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + (+q.getAttribute("data-q")));
    var form = q.closest("form");
    if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
  });

  /* ---------------------------------------------------------
     6. Theme editor: re-apply content when a section re-renders
     --------------------------------------------------------- */
  function rerun() {
    formatLiquidMoney();
    if (window.FV && window.FV.reload) window.FV.reload(savedContent());
    if (window.FV_INIT_PRODUCT_UI) { try { window.FV_INIT_PRODUCT_UI(catalogue(true)); } catch (e) {} }
    sweep();
  }
  document.addEventListener("shopify:section:load", rerun);
  document.addEventListener("shopify:section:reorder", rerun);

  window.FV_SHOPIFY = {
    config: CFG,
    url: url,
    flat: flat,
    savedContent: savedContent,
    catalogue: catalogue,
    money: money,
    legacyPage: CFG.legacyPage || "",
    productHandle: CFG.productHandle || null,
    collectionCategory: CFG.collectionCategory || null,
    sweep: sweep
  };
})();
